module.exports = __webpack_public_path__ + "annex.e5450eb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/annex.jpg
// module id = 649
// module chunks = 0